module.exports = __webpack_public_path__ + "img/up-pgh-biobank.cdaaa90c.png";